import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PublicLanding from "@/pages/PublicLanding";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import LeadDetail from "@/pages/LeadDetail";
import Campaigns from "@/pages/Campaigns";
import CampaignBuilder from "@/pages/CampaignBuilder";
import Templates from "@/pages/Templates";
import LandingPages from "@/pages/LandingPages";
import Inbox from "@/pages/Inbox";
import Tasks from "@/pages/Tasks";
import Settings from "@/pages/Settings";
import Analytics from "@/pages/Analytics";
import Help from "@/pages/Help";
import Outbox from "@/pages/Outbox";
import Review from "@/pages/Review";
import FindEmails from "@/pages/FindEmails";
import Imports from "@/pages/Imports";
import Duplicates from "@/pages/Duplicates";

function Protected({ children, admin }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 label-xs">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

const routes = [
  ["/", Dashboard], ["/leads", Leads], ["/leads/:id", LeadDetail], ["/campaigns", Campaigns],
  ["/campaigns/:id", CampaignBuilder], ["/templates", Templates], ["/landing-pages", LandingPages],
  ["/inbox", Inbox], ["/outbox", Outbox], ["/review", Review], ["/find-emails", FindEmails], ["/imports", Imports], ["/duplicates", Duplicates], ["/tasks", Tasks], ["/analytics", Analytics], ["/help", Help],
];

function isAdminHost(host) {
  const h = host.toLowerCase();
  return h.startsWith("admin.") || h.includes("emergent") || h.startsWith("localhost") || h.startsWith("127.");
}

// Public domain (meetborrowageek.ie): landing pages at "/" and "/<slug>", staff app under "/admin" ("/login" redirects there).
export const APP_BASE = !isAdminHost(window.location.host) ? "/admin" : "";

export default function App() {
  if (!isAdminHost(window.location.host)) {
    const path = window.location.pathname;
    if (path === "/login" || path === "/login/") {
      window.location.replace("/admin/login");
      return null;
    }
    if (!(path === "/admin" || path.startsWith("/admin/"))) {
      return (
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicLanding />} />
            <Route path="/:slug" element={<PublicLanding />} />
          </Routes>
        </BrowserRouter>
      );
    }
  }
  return (
    <AuthProvider>
      <BrowserRouter basename={APP_BASE || undefined}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/p" element={<PublicLanding />} />
          <Route path="/p/:slug" element={<PublicLanding />} />
          {routes.map(([p, C]) => (
            <Route key={p} path={p} element={<Protected><C /></Protected>} />
          ))}
          <Route path="/settings" element={<Protected admin><Settings /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </AuthProvider>
  );
}
